import { render } from "./page-2.vue?vue&type=template&id=da164da8&scoped=true"
import script from "./page-2.vue?vue&type=script&lang=js"
export * from "./page-2.vue?vue&type=script&lang=js"

import "./page-2.vue?vue&type=style&index=0&id=da164da8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da164da8"]])

export default __exports__